import {
    Box,
    FormControlLabel,
    IconButton,
    Radio,
    Stack,
    SxProps,
    Typography,
} from '@mui/material';
import React from 'react';
import Icon from '@mdi/react';
import { useTranslation } from 'react-i18next';
import { labelFontSemiBold, vars } from '../../../../../Theme';
import { InitialReleaseOption } from '../../../../../redux/project/sliceProjectWorkflow';

import { mdiSitemapOutline } from '@mdi/js';
import AppTooltip from '../../../AppTooltip/AppTooltip';
import { useParams } from 'react-router-dom';
import { encodeBase64String } from '../../../../../util/StringUtils';

const boxSx: SxProps = {
    border: `1px solid ${vars.lightGray}`,
    borderRadius: '4px',
    px: 1.5,
    py: '2px',
    width: '100%',
    mb: 1,
};

const optionSx: SxProps = {
    alignItems: 'flex-start',
    mr: 0,
    ml: 0,
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    flexGrow: 4,
    '& .MuiFormControlLabel-label': {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        alignSelf: 'center',
    },
    '& .MuiFormControlLabel-root': {
        mr: 0,
    },
    '& .MuiButtonBase-root ': {
        p: '6px',
    },
};

const labelSx: SxProps = {
    ml: 1.5,
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    flexGrow: 4,
    alignItems: 'center',
};

const iconButtonSx: SxProps = {
    color: vars.font,
    borderRadius: '4px',
    '&:hover': {
        backgroundColor: vars.lightGray,
    },
};

const LabelComponent = ({ option }: { option: InitialReleaseOption }) => {
    const { t } = useTranslation('translations', { keyPrefix: 'initialReleaseDialog' });
    const { workflowId, workflowTitle } = option;

    const { replicaId } = useParams();

    const openWorkflow = () => {
        window.open(`/initial-workflow-loader/${replicaId}/${workflowId}/${encodeBase64String(workflowTitle)}`);
    };

    return (
        <Stack direction='row' sx={labelSx}>
            <Typography sx={{ ...labelFontSemiBold, color: vars.font }}>{workflowTitle}</Typography>

            {replicaId && workflowId && (
                <AppTooltip title={t('openWorkflowInNewTab')} placement='top-end'>
                    <IconButton onClick={openWorkflow} sx={iconButtonSx}>
                        <Icon path={mdiSitemapOutline} size={1} />
                    </IconButton>
                </AppTooltip>
            )}
        </Stack>
    );
};

export default ({
    option,
    checked,
    handleChange,
    hasError,
    children,
}: ISelectWorkflowOptionProps) => {
    return (
        <Box
            sx={{
                ...boxSx,
                border: `1px solid ${hasError ? vars.errorDialogRed : vars.lightGray}`,
            }}
        >
            <FormControlLabel
                sx={optionSx}
                value={option.path}
                control={
                    <Radio
                        checked={checked ?? false}
                        value={option.path}
                        onChange={handleChange}
                        name={option.path}
                    />
                }
                label={<LabelComponent option={option} />}
            />
            {children}
        </Box>
    );
};

interface ISelectWorkflowOptionProps {
    option: InitialReleaseOption;
    checked: boolean;
    handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    hasError: boolean;
    children?: React.ReactNode;
}
